<template>
    <div>
        <!-- BUTTON PART LIST & PART BASKET-->
        <div class="group pa-1" v-if="partListBasket.length">
            <div class="ml-3">
                <v-flex shrink class="mr-4">
                    <v-btn class="primary" @click="to('part-list')">
                        <v-icon left class="subPrimary--text mr-2">checklist</v-icon>
                        <span class="subPrimary--text font-weight-light text-capitalize ml-2">
                            {{ 'LISTA DE PARTES'}}
                        </span>
                    </v-btn>
                </v-flex>
            </div>

            <v-divider vertical v-if="!$isPhoneDevice"></v-divider>

            <div class="group" v-show="partListBasket">
                <div>
                    <v-badge right overlap color="primary" class="ml-2 mt-3">
                        <span slot="badge">{{ partListBasket.length }}</span>
                        <v-icon>shopping_basket</v-icon>
                    </v-badge>
                </div>
                <div class="group-space">
                    <h4 class="ml-3 mt-3">PARTES SELECCIONADAS</h4>
                    <v-btn @click="showContent()" icon>
                        <v-icon v-show="this.show === false">expand_more</v-icon>
                        <v-icon v-show="this.show === true">expand_less</v-icon>
                    </v-btn>
                </div>
            </div>
        </div>

        <v-divider v-if="partListBasket.length > 0"></v-divider>

        <!-- IF V-SHOW IS TRUE -->
        <div v-show="show && !showing_selected_parts">
            <v-layout row wrap class="mb-1 ml-3">
                <v-chip v-for="(part, index) in partListBasket" :key="`tag-part-${index}`" color="orange"
                    style="z-index: 0; max-width:auto; max-height:auto;" text-color="white" close
                    @input="TOGGLE_PART_SELECTION(part)">

                    <strong style="z-index: 0; white-space: normal !important; word-wrap: break-word;">
                        {{ part.description.replace(/[, ]+/g, " ") }} / {{
                        part.mfgCode.replace(/,+/g, " ")
                        }} / {{
                        part.partNum.replace(/,+/g, " ")
                        }}
                        <!-- {{part}} -->
                    </strong>
                </v-chip>
            </v-layout>
        </div>
        <v-divider v-if="partListBasket.length"></v-divider>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { ReadMoreDirective } from "@/utils/directives";
import { debounce, to } from "@/utils/functions";

export default {
    name: "ToolbarDesktop",
    props: {
        grouped_by: {
            type: String,
            required: true
        },
        showing_selected_parts: {
            type: Boolean,
            default: false
        },
        showSelected: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            show: true,
            search: "",
        }
    },
    computed: {
        ...mapState({
            skin: state => state.settings.skin,
            group_list: state => state.parts.group_list,
            grouped_by_description: state => state.parts.grouped_by_description,
            groups: state => state.parts.groups,
            partListBasket: state => state.parts.partListBasket

        }),
        inSelected() {
            console.log("groups", this.groups);
            let parts = [];

            this.groups.forEach(group => group.parts.forEach(part => part.selected && parts.push(part)));
            this.groups_interchange.forEach(group => group.parts.forEach(part => part.selected && parts.push(part)));

            return parts
        },

        are_there_any_groups_selected() {
            return Object.values(this.group_list).length;
        },
    },
    directives: {
        ReadMore: ReadMoreDirective,
    },
    methods: {
        to,
        update_search_string: debounce(function (new_search_string) {
            console.log("Search string updated:", new_search_string);
            this.search = new_search_string;
        }, 163),
        switch_group_by() {
            this.grouped_by = this.grouped_by === 'manufacturer' ? 'description' : 'manufacturer';
        },

        showContent() {
            if (this.show == true)
                this.show = false;
            else
                this.show = true
        },
        ...mapActions({
            TOGGLE_PART_SELECTION: "parts/TOGGLE_PART_SELECTION"
        }),
    },
};
</script>

<style lang="stylus">
    .group
      display: flex
      flex: 1
    .group-space
      display: flex
      flex: 1
      justify-content: space-between
</style>
